exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.day-time-container[data-v-2b1cb6f7] {\r\n    display: inline-block;\r\n    border-bottom: 1px solid #ddd;\r\n    margin-right: 10px;\r\n    width: calc((100% - 20px) / 3);\n}\n.day-time-container[data-v-2b1cb6f7]:last-child {\r\n    margin-right: 0;\n}\r\n", ""]);

// exports
